/* B2BCANNA — loupe ronde au survol des photos produit.
   Réglages relevés sur trippy-treats.fr (Magic Zoom Plus, réécrit ici sans la bibliothèque) :
   loupe ronde de 420 px (70 % de leur photo de 600 px), grossissement ×1,5, molette pour faire
   varier (×1,2 à ×3), déplacement lissé, pastille « Survoler pour zoomer » jusqu'au premier zoom,
   désactivée sur mobile / écran tactile. */
(function () {
  if (window.__b2bLoupe) return;
  window.__b2bLoupe = true;

  var DIAMETRE = 420;          // diamètre de la loupe en px, identique à Trippy Treats…
  var TAILLE = 0.7;            // …sans dépasser 70 % de la largeur de la photo (petits écrans)
  var ZOOM = 1.5;              // grossissement de départ
  var ZOOM_MIN = 1.2, ZOOM_MAX = 3;
  var LISSAGE = 0.25;          // part du chemin parcourue à chaque image (1 = sans lissage)
  var HD = 2400;               // largeur demandée au CDN Shopify pour la loupe
  var CIBLE = 'product-media-gallery .product-media img';

  var TEXTES = {
    fr: 'Survoler pour zoomer', en: 'Hover to zoom', es: 'Pasa el ratón para ampliar',
    de: 'Zum Vergrößern darüberfahren', it: 'Passa sopra per ingrandire',
    nl: 'Beweeg over de foto om te zoomen', pt: 'Passe o rato para ampliar'
  };
  var langue = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var texte = TEXTES[langue] || TEXTES.fr;

  var souris = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

  var loupe, img = null, zoom = ZOOM;
  var boite = null;            // zone réellement occupée par la photo (object-fit)
  var cx = 0, cy = 0;          // position visée (dans la photo, px)
  var lx = 0, ly = 0;          // position lissée
  var clientX = 0, clientY = 0;
  var anim = 0;

  function creerLoupe() {
    loupe = document.createElement('div');
    loupe.className = 'b2b-loupe';
    loupe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(loupe);
  }

  function zoomable(el) {
    if (!el || el.tagName !== 'IMG' || !el.matches(CIBLE)) return false;
    var media = el.closest('.product-media');
    // pas de loupe sur les vidéos, modèles 3D ou leurs vignettes de lecture
    return !media.querySelector('video, iframe, model-viewer, deferred-media, [class*="play"]');
  }

  function urlHD(el) {
    var src = el.currentSrc || el.src;
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', HD);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) {
      return src;
    }
  }

  // Couleur de fond derrière la photo (pour les PNG transparents et les bandes de object-fit: contain)
  function fond(el) {
    for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
      var c = getComputedStyle(e).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(c)) return c;
    }
    return getComputedStyle(document.body).backgroundColor || '#fff';
  }

  function mesurer() {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
    var cs = getComputedStyle(img);
    var w = r.width, h = r.height, x = 0, y = 0;
    var ratio = nw / nh;
    if (cs.objectFit === 'contain' || cs.objectFit === 'cover' || cs.objectFit === 'scale-down') {
      var contenir = cs.objectFit !== 'cover';
      if ((r.width / r.height > ratio) === contenir) { w = r.height * ratio; } else { h = r.width / ratio; }
      var pos = cs.objectPosition.split(' ');
      var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
      if (isNaN(px)) px = 0.5;
      if (isNaN(py)) py = 0.5;
      x = (r.width - w) * px;
      y = (r.height - h) * py;
    }
    boite = { left: r.left, top: r.top, right: r.right, bottom: r.bottom, x: x, y: y, w: w, h: h, d: Math.min(DIAMETRE, r.width * TAILLE) };
  }

  function dessiner() {
    var d = boite.d;
    loupe.style.width = loupe.style.height = d + 'px';
    loupe.style.transform = 'translate(' + (boite.left + lx - d / 2) + 'px,' + (boite.top + ly - d / 2) + 'px)';
    var bw = boite.w * zoom, bh = boite.h * zoom;
    var bx = d / 2 - (lx - boite.x) * zoom, by = d / 2 - (ly - boite.y) * zoom;
    loupe.style.backgroundSize = bw + 'px ' + bh + 'px,' + bw + 'px ' + bh + 'px';
    loupe.style.backgroundPosition = bx + 'px ' + by + 'px,' + bx + 'px ' + by + 'px';
  }

  function boucle() {
    anim = 0;
    if (!img) return;
    lx += (cx - lx) * LISSAGE;
    ly += (cy - ly) * LISSAGE;
    dessiner();
    if (Math.abs(cx - lx) > 0.3 || Math.abs(cy - ly) > 0.3) anim = requestAnimationFrame(boucle);
  }

  function relancer() {
    if (!anim) anim = requestAnimationFrame(boucle);
  }

  function suivre() {
    cx = clientX - boite.left;
    cy = clientY - boite.top;
  }

  function activer(el) {
    if (!loupe) creerLoupe();
    img = el;
    zoom = ZOOM;
    mesurer();
    suivre();
    lx = cx; ly = cy;      // la loupe apparaît sous le curseur, sans glisser depuis l'ancienne place
    loupe.style.backgroundColor = fond(el);
    // deux couches : la HD par-dessus, la photo déjà affichée dessous (jamais de loupe vide)
    loupe.style.backgroundImage = 'url("' + urlHD(el) + '"),url("' + (el.currentSrc || el.src) + '")';
    dessiner();
    loupe.classList.add('is-on');
    el.closest('.product-media').classList.add('b2b-loupe-actif');
    document.documentElement.classList.add('b2b-loupe-vu');
  }

  function desactiver() {
    if (!img) return;
    var media = img.closest('.product-media');
    if (media) media.classList.remove('b2b-loupe-actif');
    img = null;
    if (loupe) loupe.classList.remove('is-on');
    if (anim) { cancelAnimationFrame(anim); anim = 0; }
  }

  function dedans() {
    return clientX >= boite.left && clientX <= boite.right && clientY >= boite.top && clientY <= boite.bottom;
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || !souris.matches) return;
    clientX = e.clientX;
    clientY = e.clientY;
    if (img) {
      if (e.buttons || !img.isConnected || !dedans()) { desactiver(); } else { suivre(); relancer(); return; }
    }
    if (e.buttons) return;
    var cible = e.target;
    if (zoomable(cible)) activer(cible);
  }, { passive: true });

  document.addEventListener('pointerdown', desactiver, true);
  document.documentElement.addEventListener('mouseleave', desactiver);
  window.addEventListener('blur', desactiver);

  // la page défile sous la souris immobile : on remesure, et on éteint si la photo est sortie
  window.addEventListener('scroll', function () {
    if (!img) return;
    mesurer();
    if (!dedans()) { desactiver(); return; }
    suivre();
    lx = cx; ly = cy;
    dessiner();
  }, { passive: true });
  window.addEventListener('resize', desactiver);

  // molette : fait varier le grossissement tant que la loupe est ouverte
  document.addEventListener('wheel', function (e) {
    if (!img) return;
    e.preventDefault();
    var pas = e.deltaY < 0 ? 1.1 : 1 / 1.1;
    zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoom * pas));
    dessiner();
  }, { passive: false });

  // pastille « Survoler pour zoomer » sur chaque photo, jusqu'au premier zoom
  var ICONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/></svg>';

  function pastilles() {
    if (!souris.matches || document.documentElement.classList.contains('b2b-loupe-vu')) return;
    var imgs = document.querySelectorAll(CIBLE);
    for (var i = 0; i < imgs.length; i++) {
      var media = imgs[i].closest('.product-media');
      if (!zoomable(imgs[i]) || media.querySelector('.b2b-loupe-hint')) continue;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var p = document.createElement('span');
      p.className = 'b2b-loupe-hint';
      p.innerHTML = ICONE + '<span></span>';
      p.lastChild.textContent = texte;
      media.appendChild(p);
    }
  }

  function demarrer() {
    pastilles();
    // la galerie est reconstruite au changement de déclinaison : on repose les pastilles
    var g = document.querySelector('product-media-gallery');
    if (g && window.MutationObserver) {
      var attente = 0;
      new MutationObserver(function () {
        clearTimeout(attente);
        attente = setTimeout(pastilles, 100);
      }).observe(g.parentElement || g, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
